import React from 'react';

// A tela de emissão mostra primeiro os percentuais relevantes.
// O cadastro fiscal completo continua acessível em Dados Cadastrais.
export default function NfseFiscalFields({ values = {}, onChange, disabled = false, inherit = false, issApplicable = true, issRequired = false, compact = false }) {
  const render = ([label, key, length]) => (
    <label key={key} className="min-w-0 text-sm font-medium text-slate-700">{label}
      <input value={values[key] ?? ''} onChange={event => onChange(key, event.target.value)}
        disabled={disabled || (key === 'issRate' && !issApplicable)}
        required={key === 'issRate' && issRequired}
        inputMode={length ? 'numeric' : 'decimal'} maxLength={length || 6}
        placeholder={inherit ? 'Padrão geral' : ''}
        className="mt-1 block min-h-[44px] w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm focus:border-blue-400 disabled:opacity-50"/>
    </label>
  );
  const codes = [['NBS', 'nbs', 9], ['INDOP', 'indOp', 6], ['CST', 'cst', 3], ['CCLASSTRIB', 'cClassTrib', 6]];
  const rates = [['Alíquota do ISS (%)', 'issRate', null], ['Simples Nacional (%)', 'simplesRate', null]];
  if (compact) return <div className="space-y-3">
    <div className="grid gap-3 sm:grid-cols-2">{rates.map(render)}</div>
    <details className="rounded-xl border border-slate-200 bg-slate-50/50 px-4 py-3">
      <summary className="cursor-pointer text-sm font-medium text-slate-700">Códigos fiscais avançados <span className="text-xs font-normal text-slate-500">(NBS e IBS/CBS)</span></summary>
      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">{codes.map(render)}</div>
      <p className="mt-3 text-xs text-slate-500">Use os códigos definidos para o serviço e para a competência. Não altere códigos apenas para contornar uma rejeição fiscal.</p>
    </details>
  </div>;
  return <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
    {[...codes, ...rates].map(render)}
  </div>;
}
